class TabSelector extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.querySelectorAll(".tab");
        this.slidesContainer = this.querySelector(".slides");

        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                this.select(tab);
            })
        })
    }

    select(tab) {
        this.tabs.forEach((otherTab) => {
            if (otherTab.classList.contains("selected")) {
                otherTab.classList.remove("selected");
            }
        })

        var index = tab.dataset.index;
        tab.classList.add("selected");

        this.slidesContainer.dataset.index = index;
        this.slidesContainer.style.translate = `${index * -100}%`
    }
}

customElements.define('tab-selector', TabSelector)